// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"896":"05e210da","1223":"1e817ddf","7460":"272ef946","9371":"272ef946"}[chunkId] + ".chunk.css";
};